import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Tooltip } from "primereact/tooltip";

import { actionTooltipProps, Dialog, DialogFooter, FormField } from "@/ds";
import {
  CODE_FIELD_ID,
  CODE_LOCKED_MESSAGE,
  DESCRIPTION_MAX_LENGTH,
  DESCRIPTION_ROWS,
  EDIT_PERMISSION_LABELS,
  EDIT_PERMISSION_TITLE,
  NAME_MAX_LENGTH,
} from "./edit-permission-dialog.constants";
import styles from "./edit-permission-dialog.module.scss";
import type { EditPermissionDialogViewModel } from "./types-edit-permission-dialog";

const CODE_TOOLTIP = actionTooltipProps(CODE_LOCKED_MESSAGE, { position: "right" });

/** Modal Editar permissão (Figma 5333:105145): código bloqueado com a MS002 no hover; nome e descrição obrigatórios. */
export function EditPermissionDialogView({
  formId,
  codigo,
  nome,
  descricao,
  isSubmitting,
  enviar,
  cancelar,
}: EditPermissionDialogViewModel) {
  return (
    <Dialog
      visible
      size="sm"
      className={styles.dialog}
      header={EDIT_PERMISSION_TITLE}
      onHide={cancelar}
      locked={isSubmitting}
      footer={
        <DialogFooter
          cancelVariant="text"
          cancelTestId="edit-permission-cancel"
          confirmTestId="edit-permission-save"
          confirmLabel="Salvar"
          formId={formId}
          loading={isSubmitting}
          locked={isSubmitting}
          onCancel={cancelar}
        />
      }
      data-testid="edit-permission-dialog"
    >
      <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
        <FormField.Root disabled>
          <FormField.Label>{EDIT_PERMISSION_LABELS.codigo}</FormField.Label>
          {/* O input desabilitado não recebe eventos de mouse: a tooltip fica no invólucro. */}
          <span
            id={CODE_FIELD_ID}
            className={styles.codigo}
            data-testid="edit-permission-code-field"
          >
            <FormField.Control>
              <InputText
                value={codigo}
                disabled
                aria-description={CODE_LOCKED_MESSAGE}
                data-testid="edit-permission-code"
              />
            </FormField.Control>
          </span>
        </FormField.Root>

        <FormField.Root required error={nome.error} disabled={isSubmitting}>
          <FormField.Label>{EDIT_PERMISSION_LABELS.nome}</FormField.Label>
          <FormField.Control>
            <InputText
              value={nome.value}
              maxLength={NAME_MAX_LENGTH}
              onChange={(event) => nome.digitar(event.currentTarget.value)}
              data-testid="edit-permission-name"
            />
          </FormField.Control>
          <FormField.Error data-testid="edit-permission-name-error" />
        </FormField.Root>

        <FormField.Root required error={descricao.error} disabled={isSubmitting}>
          <FormField.Label>{EDIT_PERMISSION_LABELS.descricao}</FormField.Label>
          <FormField.Control>
            <InputTextarea
              value={descricao.value}
              maxLength={DESCRIPTION_MAX_LENGTH}
              rows={DESCRIPTION_ROWS}
              onChange={(event) => descricao.digitar(event.currentTarget.value)}
              data-testid="edit-permission-description"
            />
          </FormField.Control>
          <FormField.Error data-testid="edit-permission-description-error" />
        </FormField.Root>
      </form>

      <Tooltip target={`#${CODE_FIELD_ID}`} {...CODE_TOOLTIP} />
    </Dialog>
  );
}
